<template>
  <app-input-group
    v-model="displayValue"
    :prefix="prefix"
    type="text"
    :label="label"
    :tooltip="tooltip"
    :tooltip-centered="tooltipCentered"
    :disabled="disabled"
    @keypress="onKeypress($event)"
  >
    <template v-slot:tooltipHeader>
      <slot name="tooltipHeader"/>
    </template>
    <template v-slot:tooltipText>
      <slot name="tooltipText"/>
    </template>
  </app-input-group>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    crypto: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '$',
    },
    tooltipCentered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isInputActive: false,
    };
  },
  methods: {
    onKeypress(e) {
      const isNotNumberCode = e.keyCode < 48 || e.keyCode > 57;
      const isDecimalPoint = e.keyCode === 46;
      if (this.crypto) {
        if (isNotNumberCode && !isDecimalPoint) {
          e.preventDefault();
        }
      } else if (isNotNumberCode) {
        e.preventDefault();
      }
    },
  },
  computed: {
    displayValue: {
      get() {
        // For cryptocurrencies the number of digits after comma is not restricted
        if (this.crypto) {
          return `${Number(this.value).toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')}`;
        }
        // For natural currencies we allow only integer values
        return `${Number(this.value).toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')}`;
      },
      set(modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        let newValue = parseFloat(modifiedValue.replace(/[(,)]/g, ''));
        // Ensure that it is not NaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(newValue)) {
          newValue = 0;
        }
        // Note: we cannot set this.value as it is a "prop".
        // It needs to be passed to parent component.
        // $emit the event so that parent component gets it
        this.$emit('input', newValue);
      },
    },
  },
};
</script>
